import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pathname, setPathname] = useState(window.location.pathname);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10);
        window.addEventListener("scroll", onScroll);

        const onPopState = () => setPathname(window.location.pathname);
        window.addEventListener("popstate", onPopState);

        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("popstate", onPopState);
        };
    }, []);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
    ];

    return (
        <header
            className={`
        fixed top-0 left-0 w-full z-50
        transition-all duration-300
        ${scrolled ? "bg-black/95 backdrop-blur shadow-lg" : "bg-black"}
      `}
        >
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                {/* Logo */}
                <Link to="/" className="flex-shrink-0">
                    <img
                        src="/logo.png"
                        alt="Fernando Logo"
                        className="h-20 w-48"
                    />
                </Link>

                {/* Navegação desktop */}
                <nav className="hidden md:flex gap-8 text-sm font-semibold uppercase tracking-wide">
                    {navLinks.map((link) => (
                        <Link
                            key={link.href}
                            to={link.href}
                            className={`
                relative text-white/80 hover:text-white transition
                ${pathname === link.href ? "text-white" : ""}
              `}
                        >
                            {link.label}
                            {pathname === link.href && (
                                <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-red-6001" />
                            )}
                        </Link>
                    ))}
                </nav>

                {/* CTA desktop */}
                <div className="hidden md:block">
                    <Link
                        to="/contato"
                        className="
              border border-white
              px-5 py-2
              rounded-full
              text-sm font-semibold
              text-white
              bg-red-600
              hover:bg-red-500 
              transition
            "
                    >
                        Fale Conosco
                    </Link>
                </div>

                {/* Menu mobile */}
                <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="md:hidden text-3xl text-white"
                >
                    {menuOpen ? <HiX /> : <HiMenu />}
                </button>
            </div>

            {/* Menu mobile dropdown */}
            {menuOpen && (
                <div className="md:hidden bg-black border-t border-white/10">
                    <ul className="flex flex-col px-6 py-6 gap-4 text-white text-sm font-semibold uppercase">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className={`block ${pathname === link.href ? "opacity-100" : "opacity-70"
                                        }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
